export default "__VITE_ASSET__e63de2f9__"